export const DeleteFile = async (fileId: number) => {
	let url = `/api/fileuploadservice/Delete?FileId=${fileId}`;
	let options = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
		},
		body: JSON.stringify({ fileId }),
	};
	const response = await fetch(url, options);
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return response;
};
